import { useRouteError } from 'react-router-dom';
import { ErrorView } from './ErrorView';

/**
 * Route-level error boundary using layout-aware ErrorFallback.
 * This is used as `errorElement` in route config.
 */
export const GRouteErrorBoundary = () => {
  const error = useRouteError();
  // Never expose error.message unless you're 100% sure it's user-friendly
  return <ErrorView cause={error} variant="centered-panel" />;
};
